// This icon file is generated automatically.
var PFundOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M13.47 1.56h-13a.5.5 0 00-.5.5v10c0 .28.22.5.5.5h13a.5.5 0 00.5-.5v-10a.5.5 0 00-.5-.5zm-.63 9.88H1.1V2.69h11.75v8.75zm-10.3-1.29c.06.05.14.05.19 0l2.69-2.7 1.79 1.8c.05.04.13.04.17 0l4.65-4.65a.13.13 0 000-.17l-.58-.58a.13.13 0 00-.18 0L7.3 7.83l-1.8-1.8a.13.13 0 00-.17 0L1.98 9.4a.13.13 0 000 .17l.57.58z", "fill-rule": "nonzero" } }] }, "name": "p-fund", "theme": "outlined" };
export default PFundOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PFundOutlined.js
// module id = 3434
// module chunks = 0